/**
 * @generated SignedSource<<b841c5e6a1fc00565ab62f442cd31d38>>
 * @relayHash b95a4917201b653876409165c4341399
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c3932cee4cd0dd92c92bce689e05de6870f5ca90c6ec1586f4fae9472ecae2e

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StakeholderCommsStakeholderStatus = "ACTIVE" | "DELETED" | "QUARANTINED" | "%future added value";
export type StakeholderCommsStakeholderType = "EXTERNAL" | "INTERNAL" | "TEAM" | "%future added value";
export type StakeholderCommsStakeholderConnectionFilter = {
  status?: ReadonlyArray<StakeholderCommsStakeholderStatus> | null | undefined;
  type?: ReadonlyArray<StakeholderCommsStakeholderType> | null | undefined;
};
export type StakeholdersPageQuery$variables = {
  filter?: StakeholderCommsStakeholderConnectionFilter | null | undefined;
};
export type StakeholdersPageQuery$data = {
  readonly stakeholderComms_listStakeholders: {
    readonly " $fragmentSpreads": FragmentRefs<"StakeholderPageContent">;
  };
};
export type StakeholdersPageQuery = {
  response: StakeholdersPageQuery$data;
  variables: StakeholdersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      }
    ],
    "kind": "ObjectValue",
    "name": "listStakeholderConnectionInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "avatar"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "StakeholderCommsStakeholderConnection",
          "kind": "LinkedField",
          "name": "stakeholderComms_listStakeholders",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "StakeholderPageContent"
            }
          ]
        },
        "action": "THROW",
        "path": "stakeholderComms_listStakeholders"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StakeholdersPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsStakeholderConnection",
        "kind": "LinkedField",
        "name": "stakeholderComms_listStakeholders",
        "plural": false,
        "selections": [
          {
            "concreteType": "StakeholderCommsStakeholder",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "StakeholderCommsNotificationPreference",
                "kind": "LinkedField",
                "name": "notificationPreference",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "emailId"
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "concreteType": "StakeholderCommsGroups",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "type"
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0c3932cee4cd0dd92c92bce689e05de6870f5ca90c6ec1586f4fae9472ecae2e",
    "metadata": {},
    "name": "StakeholdersPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "da40686837aa2f310560c0cd8cc0d089";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
